import { HttpClient } from "@angular/common/http";
import { Injectable, signal } from "@angular/core";
import { AlertStatus } from "@models/alerts/alerts-enums";
import { FilterModel } from "ag-grid-enterprise";
import { Subject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class AlertsService {
  private readStatusUpdatedSource = new Subject<void>();
  public readStatusUpdated$ = this.readStatusUpdatedSource.asObservable();
  numberColumnForExport = signal(0);

  constructor(private api: HttpClient) { }

  public notifyReadStatusUpdated() {
    this.readStatusUpdatedSource.next();
  }

  public getRequiredAttentionFilterModel(): FilterModel {
    return  {
      needAttention: {
        filterType: 'set',
        values: ['true']
      }
    }
  }

  public getPostponedAttentionFilterModel(): FilterModel {
    return  {
      status: {
        filterType: 'set',
        values: [AlertStatus.Postponed.toString()]
      },
    }
  }
}
